var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass:
        "c-restrictiveIconComponent tooltip-multiline tooltip-bottom-right",
      attrs: {
        "data-tooltip":
          "Assine um plano CoteiBem para desbloquear este recurso.",
      },
    },
    [
      _c(
        "svg",
        {
          class: "c-restrictiveIconComponent_icon",
          attrs: {
            xmlns: "http://www.w3.org/2000/svg",
            width: "12",
            height: "15",
            viewBox: "0 0 12 15",
            "svg-inline": "",
            role: "presentation",
            focusable: "false",
            tabindex: "-1",
          },
        },
        [
          _c("defs", [
            _c("clipPath", { attrs: { id: "a" } }, [
              _c("path", {
                attrs: {
                  "data-name": "Retângulo 1265",
                  fill: "rgba(61,61,61,0.75)",
                  d: "M0 0h12v15H0z",
                },
              }),
            ]),
          ]),
          _c("g", { attrs: { "data-name": "Grupo 4727" } }, [
            _c(
              "g",
              {
                attrs: {
                  "data-name": "Grupo 4726",
                  "clip-path": "url(#a)",
                  fill: "rgba(61,61,61,0.75)",
                },
              },
              [
                _c("path", {
                  attrs: {
                    "data-name": "Caminho 4015",
                    d: "M9.75 15h-7.5A2.252 2.252 0 010 12.75v-4.5A2.252 2.252 0 012.25 6h7.5A2.253 2.253 0 0112 8.25v4.5A2.253 2.253 0 019.75 15m-7.5-7.5a.751.751 0 00-.75.75v4.5a.751.751 0 00.75.75h7.5a.75.75 0 00.749-.75v-4.5a.75.75 0 00-.749-.75z",
                  },
                }),
                _c("path", {
                  attrs: {
                    "data-name": "Caminho 4016",
                    d: "M9.75 7.5A.75.75 0 019 6.75V4.5a2.977 2.977 0 00-.878-2.121 3.072 3.072 0 00-4.243 0A2.982 2.982 0 003 4.5v2.25a.75.75 0 11-1.5 0V4.5a4.5 4.5 0 019 0v2.25a.75.75 0 01-.75.75",
                  },
                }),
                _c("path", {
                  attrs: {
                    "data-name": "Caminho 4017",
                    d: "M6.001 11.812a1.313 1.313 0 010-2.625z",
                  },
                }),
                _c("path", {
                  attrs: {
                    "data-name": "Caminho 4018",
                    d: "M6 11.812V9.187a1.313 1.313 0 010 2.625",
                  },
                }),
              ]
            ),
          ]),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }